module.exports = __webpack_public_path__ + "static/media/tandc.0739d2b4.png";